/* eslint-disable */
import apiService from 'util/apiService';
import {
  ADMIN_USER_ROLE_GET_STATUS_COUNT,
  ADMIN_USER_ROLE_GET_STATUS_COUNT_SUCCESS,
  ADMIN_USER_ROLE_GET_STATUS_COUNT_FAILURE,
  ADMIN_USER_ROLE_ADD_USER,
  ADMIN_USER_ROLE_ADD_USER_SUCCESS,
  ADMIN_USER_ROLE_ADD_USER_FAILURE,
  ADMIN_USER_ROLE_UPDATE_FILTER,
  ADMIN_USER_ROLE_SET_ACTIVE_STATUS,
  ADMIN_USER_ROLE_TOGGLE_ADD_USER_DRAWER,
  ADMIN_USER_ROLE_CLEAR_USER_FORM,
  ADMIN_USER_ROLE_GET_ROLES,
  ADMIN_USER_ROLE_GET_ROLES_SUCCESS,
  ADMIN_USER_ROLE_GET_ROLES_FAILURE,
  ADMIN_USER_ROLE_GET_ROLES_LIST,
  ADMIN_USER_ROLE_GET_ROLES_LIST_SUCCESS,
  ADMIN_USER_ROLE_GET_ROLES_LIST_FAILURE,
  ADMIN_USER_ROLE_SET_SELECTED_CLIENT,
  ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT,
  ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT_SUCCESS,
  ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT_FAILURE,
  ADMIN_USER_ROLE_INCREMENT_CLEAR_SELECTION,
} from './constants';
import { setCommonAlerts } from 'modules/cbre-flow-Common/actions';
import { getUserConfig } from 'modules/cbre-flow-api-ducks';

// Action to get user status counts
export const getUserStatusCount = (url) => {
  return (dispatch) => {
    dispatch({ type: ADMIN_USER_ROLE_GET_STATUS_COUNT });

    return apiService
      .get(url)
      .then((response) => {
        const { allUserCount: totalUsers  = 0, approvalNeededCount: needApproval = 0 } = response.data || {};

        dispatch(
          updateUserStatusCount({
            totalUsers,
            needApproval,
          }),
        );
      })
      .catch((error) => {
        console.error('Error fetching user status count:', error);
        dispatch({
          type: ADMIN_USER_ROLE_GET_STATUS_COUNT_FAILURE,
          payload: error,
        });
      });
  };
};

export const updateUserStatusCount = (counts) => {
  return {
    type: ADMIN_USER_ROLE_GET_STATUS_COUNT_SUCCESS,
    payload: counts,
  };
};

// Action to add a new user
export const addUser = (url, userData) => {
  return (dispatch) => {
    dispatch({ type: ADMIN_USER_ROLE_ADD_USER });

    return apiService
      .post(url, userData)
      .then((response) => {
        if (!response.data?.success) {
          const errorMsg = response.data?.message || 'Error adding user.';
          throw new Error(errorMsg);
        }
        dispatch({
          type: ADMIN_USER_ROLE_ADD_USER_SUCCESS,
          payload: response.data,
        });

        // Close the drawer after successful user addition
        dispatch(
          toggleAddUserDrawer({ isOpen: false, mode: 'add', selectedRows: [] }),
        );
        dispatch(
          setCommonAlerts({
            message: 'User added successfully.',
            type: 'success',
          }),
        );

        return response;
      })
      .catch((error) => {
        console.error('Error adding user:', error);
        dispatch(
          setCommonAlerts({
            message: error?.message || 'Error adding user.',
            type: 'failure',
          }),
        );
        dispatch({
          type: ADMIN_USER_ROLE_ADD_USER_FAILURE,
          payload: error,
        });

        throw error;
      });
  };
};

// Action to add a new user
export const setPrimaryRoleAction = (url, userData) => {
  return (dispatch) => {
    dispatch({ type: ADMIN_USER_ROLE_ADD_USER });

    return apiService
      .put(url, userData)
      .then((response) => {
        if (!response.data?.successCount) {
          const errorMsg =
            response.data?.message || 'Error setting primary role.';
          throw new Error(errorMsg);
        }
        dispatch({
          type: ADMIN_USER_ROLE_ADD_USER_SUCCESS,
          payload: response.data,
        });

        dispatch(
          setCommonAlerts({
            message: 'Primary role set successfully.',
            type: 'success',
          }),
        );

        return response;
      })
      .catch((error) => {
        console.error('Error setting primary role:', error);
        dispatch(
          setCommonAlerts({
            message: error?.message || 'Error setting primary role.',
            type: 'failure',
          }),
        );
        dispatch({
          type: ADMIN_USER_ROLE_ADD_USER_FAILURE,
          payload: error,
        });

        throw error;
      });
  };
};

// Action to add a new user
export const editBulkUser = (url, userData) => {
  return (dispatch) => {
    dispatch({ type: ADMIN_USER_ROLE_ADD_USER });

    return apiService
      .put(url, userData)
      .then((response) => {
        if (!response.data?.successCount) {
          const errorMsg =
            response.data?.message || 'Error in updating user(s).';
          throw new Error(errorMsg);
        }
        dispatch({
          type: ADMIN_USER_ROLE_ADD_USER_SUCCESS,
          payload: response.data,
        });

        dispatch(
          setCommonAlerts({
            message: 'User(s) updated successfully.',
            type: 'success',
          }),
        );
        dispatch(
          toggleAddUserDrawer({ isOpen: false, mode: 'add', selectedRows: [] }),
        );
        return response;
      })
      .catch((error) => {
        console.error('Error setting primary role:', error);
        dispatch(
          setCommonAlerts({
            message: error?.message || 'Error in updating user(s).',
            type: 'failure',
          }),
        );
        dispatch({
          type: ADMIN_USER_ROLE_ADD_USER_FAILURE,
          payload: error,
        });

        throw error;
      });
  };
};

// Action to update filter
export const updateFilter = (filter) => {
  return {
    type: ADMIN_USER_ROLE_UPDATE_FILTER,
    payload: filter,
  };
};

// Action to set active status for filtering
export const setActiveStatus = (status) => {
  return {
    type: ADMIN_USER_ROLE_SET_ACTIVE_STATUS,
    payload: status,
  };
};

// Action to toggle add user drawer
export const toggleAddUserDrawer = ({ isOpen, mode, selectedRows }) => {
  return {
    type: ADMIN_USER_ROLE_TOGGLE_ADD_USER_DRAWER,
    payload: { isOpen, mode, selectedRows },
  };
};

// Action to clear user form
export const clearUserForm = () => {
  return {
    type: ADMIN_USER_ROLE_CLEAR_USER_FORM,
  };
};

// Action to get available roles
export const getRoles = (url) => {
  return (dispatch) => {
    dispatch({ type: ADMIN_USER_ROLE_GET_ROLES });

    return apiService
      .get(url)
      .then((response) => {
        dispatch({
          type: ADMIN_USER_ROLE_GET_ROLES_SUCCESS,
          payload: response.data?.roles || [],
        });
      })
      .catch((error) => {
        console.error('Error fetching roles:', error);
        dispatch({
          type: ADMIN_USER_ROLE_GET_ROLES_FAILURE,
          payload: error,
        });
      });
  };
};

// Action to get roles list from api/roles/list
export const getRolesList = (callback) => {
  return (dispatch, getState) => {
    const state = getState();
    const apiBaseUrl = state.config?.client?.flowApiUrl || '';
    const url = `${apiBaseUrl}api/roles/list`;
    dispatch({ type: ADMIN_USER_ROLE_GET_ROLES_LIST });

    return apiService
      .get(url)
      .then((response) => {
        const myRole =
          state['cbre-flow-api-ducks']?.UserInfo?.userInfo?.userDetails
            ?.currentContext?.role || {};
        
        // Define role hierarchy (1 = highest, 6 = lowest)
        const roleHierarchy = {
          'SYS_ADMIN': 1,
          'CBRE_ACCOUNT_ADMIN': 2,
          'CBRE_FS_COORDINATOR': 3,
          'CLIENT_ACCESS_MANAGER': 4,
          'CLIENT_LAB_MANAGER': 5,
          'CLIENT_SCIENTIST': 6
        };
        
        const myRoleLevel = roleHierarchy[myRole.translationKey] || 999; // Default to lowest if role not found
        
        const filteredRoles = (response.data?.roles || []).filter((role) => {
          const roleLevel = roleHierarchy[role.translationKey];
          
          // Don't show roles that are above my hierarchy level or same as my role
          if (roleLevel && roleLevel <= myRoleLevel) {
            return false;
          }
          
          // Only show roles below my hierarchy level
          return roleLevel > myRoleLevel;
        });
        dispatch({
          type: ADMIN_USER_ROLE_GET_ROLES_LIST_SUCCESS,
          payload: response.data?.roles || [],
        });
        if (callback) callback();
      })
      .catch((error) => {
        console.error('Error fetching roles list:', error);
        dispatch({
          type: ADMIN_USER_ROLE_GET_ROLES_LIST_FAILURE,
          payload: error,
        });
      });
  };
};

// Action to increment clear selection count (for resetting selections)
export const incrementClearSelection = () => {
  return {
    type: ADMIN_USER_ROLE_INCREMENT_CLEAR_SELECTION,
  };
};

// Action to set selected client
export const setSelectedClient = (client) => {
  return {
    type: ADMIN_USER_ROLE_SET_SELECTED_CLIENT,
    payload: client,
  };
};

// Action to update selected client in the API
export const updateSelectedClientApi = ({ userId, clientCode }) => {
  return (dispatch, getState) => {
    dispatch({ type: ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT });

    const state = getState();
    const apiBaseUrl = state.config?.client?.flowApiUrl || '';
    const url = `${apiBaseUrl}api/users/group-active-client`;

    return apiService
      .post(url, { userId, clientCode })
      .then(async (response) => {
        if(!response || !response.data) {
          const errorMsg = response?.data?.message || 'Error updating client.';
          throw new Error(errorMsg);
        }
        dispatch({
          type: ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT_SUCCESS,
          payload: response.data,
        });

        // Refresh user config so getUserAccess selector gets latest active client context.
        await dispatch(
          getUserConfig({ apiUrl: `${apiBaseUrl}api/users/config` }),
        );

        dispatch(
          setCommonAlerts({
            message: 'Client updated successfully.',
            type: 'success',
          }),
        );
        return response;
      })
      .catch((error) => {
        console.error('Error updating client:', error);
        dispatch(
          setCommonAlerts({
            message: error?.message || 'Error updating client.',
            type: 'failure',
          }),
        );
        dispatch({
          type: ADMIN_USER_ROLE_UPDATE_SELECTED_CLIENT_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};
